module.exports = __webpack_public_path__ + "static/media/toggle_detail_floor.afb88c60.svg";